import { defineRule } from 'vee-validate';
import { i18n } from '@/i18n';

defineRule('iban', (value) => {
  const re = /^[A-Z]{2}\d{2}[A-Z0-9]{18,32}$/;

  return re.test(String(value)) || i18n.global.t('Validation.IBAN');
});
